// /help/privacy - Phase 1 stub. Per task 1.13a.

export function renderHelpPrivacy(target: HTMLElement): void {
  target.innerHTML = '';
  const article = document.createElement('article');
  article.className = 'help-page';

  article.innerHTML = `
    <h1 class="help-title">Privacy</h1>
    <p class="help-body">
      nostr.gives stores your stats in <strong>localStorage</strong> only.
      Daily streaks, win counts, and the puzzle you have already played
      today live in your browser. We do not sync that data to our servers.
    </p>
    <p class="help-body">
      When you choose to share a score, we publish a kind 1 note to Nostr
      relays you select (or the project defaults). That is the only outbound
      data we touch, and you trigger it explicitly. There is no analytics
      script, no tracking pixel, no third-party cookies.
    </p>
    <p class="help-body">
      v1 - more detail as the project matures.
    </p>
    <p class="help-back"><a class="help-link" href="#/">Back to home</a></p>
  `;

  target.appendChild(article);
}
